export default __webpack_public_path__ + "static/google_play_badge_en-563fb2055a59162fee9e8fd4cde4cbe9.svg";